
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1985',
  depVersions: {
  "customer-portal-app": "static-1.1985",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.457",
  "data-fetching-client": "static-1.9582",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25080",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5501",
  "hs-test-utils": "static-1.7919",
  "hub-http": "static-1.6126",
  "hub-http-shared-msw-handlers": "static-1.9746",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.17961",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11364",
  "I18n": "static-7.1604",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6375",
  "payment-link-components": "static-1.23263",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6880",
  "quartz-core": "static-1.6099",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10116",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5273",
  "rich-text-lib": "static-1.19670",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17854",
  "ui-components-test-utils": "static-1.5502",
  "UIComponents": "static-3.8311",
  "foundations-assets": "static-1.4757",
  "foundations-components": "static-1.7739",
  "foundations-theming": "static-1.4321",
  "foundations-theming-specialty": "static-1.2037",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.717",
  "quartz-config": "static-1.658",
  "quartz-routing": "static-1.310",
  "quick-fetch": "static-1.3841",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16564",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8052",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4676",
  "ui-addon-react-router-dom": "static-1.9452",
  "usage-tracker": "static-1.7243",
  "usage-tracker-anonymous": "static-1.5660",
  "usage-tracker-core": "static-1.7093",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3332",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3157",
  "quartz-webpack": "static-1.3104",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7567",
  "frontend-preferences-client": "static-1.7831",
  "laboratory-lib": "static-3.7066",
  "onboarding-scopes": "static-1.6372",
  "rpc-client-utils": "static-1.4551",
  "ui-addon-opt": "static-4.8289",
  "HeadJS": "static-2.736",
  "hs-test-utils-bend-plugin": "static-1.3030",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4003",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7616",
  "cssUtils": "static-1.771",
  "customer-data-ui-utilities": "static-1.9733",
  "HubStyle": "static-2.11672",
  "knowledge-content-types": "static-1.8453",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.555",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9794",
  "ui-addon-i18n": "static-1.11056",
  "ui-business-units-lib": "static-1.8948",
  "ui-shepherd-react": "static-3.10055",
  "video-components-external": "static-1.10970",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4231",
  "commerce-tours-lib": "static-1.5923",
  "customer-data-properties": "static-1.51214",
  "getting-started-shared-tasks": "static-1.18228",
  "growth-onboarding-reliability": "static-1.4992",
  "onboarding-tours": "static-1.16430",
  "reference-resolvers-lite": "static-1.7998",
  "sales-checkout-service-client": "static-1.3569",
  "ui-addon-iframeable": "static-1.8957",
  "user-context": "static-1.5008",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4577",
  "icons": "static-2.639",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.555",
  "quartz-head": "static-1.545",
  "quartz-test": "static-1.555",
  "quartz-tracking": "static-1.259",
  "ui-fonts": "static-1.626",
  "usage-tracker-container": "static-1.7233",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9337",
  "data-token-picker": "static-1.16241",
  "FileManagerLib": "static-1.38963",
  "property-translator": "static-1.5314",
  "atom": "static-1.4978",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5701",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5222",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1131",
  "bend-plugin-foundations-components": "static-1.4008",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1553",
  "bend-plugin-foundations-theming": "static-1.2804",
  "foundations-theming-base": "static-1.3306",
  "stylex": "static-1.30",
  "interframe": "static-3.4670",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5657",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4380",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3063",
  "inbound-db-properties-service-client": "static-1.3771",
  "superstore": "static-1.4676",
  "chirp-fetch": "static-1.1788",
  "feedback-loader": "static-1.29122",
  "ai-components-ui-library": "static-1.8700",
  "ui-addon-video-player": "static-1.8604",
  "ui-coaching-tips": "static-1.28275",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4526",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2401",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8075",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4558",
  "content-media-composition-data-lib": "static-1.11944",
  "content-media-compositions": "static-2.15951",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4060",
  "magpie-lib": "static-1.5502",
  "magpie-types": "static-1.4962",
  "media-bridge-lib": "static-1.18762",
  "video-data-lib": "static-1.34628",
  "commerce-products-lib": "static-1.9184",
  "crm-message-bus": "static-1.42718",
  "growth-data-modal": "static-1.5285",
  "hubspot-apollo-client": "static-1.4785",
  "onboarding-tours-client": "static-1.4644",
  "calling-global-api": "static-1.64131",
  "calling-internal-common": "static-1.31209",
  "calling-lifecycle-internal": "static-1.65513",
  "calling-lifecycle-messages": "static-1.57807",
  "conditional-properties-service-client": "static-1.3722",
  "crm-links": "static-1.6185",
  "customer-data-objects-ui-components": "static-1.12928",
  "customer-data-properties-shared-msw-handlers": "static-1.9073",
  "customer-data-property-utils": "static-1.7992",
  "external-options-client-types": "static-1.4083",
  "file-manager-components": "static-1.23323",
  "framework-data-schema-resolvers": "static-1.6782",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3515",
  "inbounddb-objects-service-types": "static-1.4148",
  "meetings-icalendar-utils-lib": "static-1.537",
  "multi-currency-client-types": "static-1.3616",
  "object-builder-ui-client": "static-1.48418",
  "pipeline-validation-client-types": "static-1.3891",
  "property-value-citations": "static-1.1828",
  "pulse": "static-1.452",
  "smart-property-lib": "static-1.6474",
  "tiered-pricing": "static-1.1025",
  "ui-addon-form-validation": "static-1.10898",
  "growth-onboarding-confetti": "static-1.2978",
  "growth-onboarding-next-action-utils": "static-1.1635",
  "navigation-components": "static-1.17675",
  "onboarding-tours-utils": "static-1.496",
  "ui-shepherd-tracker": "static-1.7436",
  "ui-universal-auth": "static-1.8847",
  "batch-promise": "static-1.1460",
  "navigation-messaging": "static-1.7002",
  "getting-started-shared-tasks-store": "static-1.17346",
  "hubspotter-http-shared-msw-handlers": "static-1.9744",
  "usage-tracker-session-replay": "static-1.4929",
  "audio-components": "static-1.5778",
  "FileManagerCore": "static-1.38822",
  "FileManagerImages": "static-1.36474",
  "video-components": "static-1.12973",
  "foundations-components-legacy": "static-1.764",
  "nav-client-types": "static-1.2265",
  "purchase-motions-api": "static-1.5704",
  "self-service-api": "static-1.10152",
  "signup-constants": "static-1.18681",
  "signup-ui-url-generator": "static-2.7943",
  "usage-tracker-public": "static-1.7054",
  "chatspot-core": "static-1.20847",
  "ContentUtils": "static-1.68066",
  "copilot-toolkit": "static-1.10864",
  "growth-onboarding-feedback-components": "static-1.6489",
  "reactive-lib": "static-1.631",
  "simple-logging-lib": "static-1.2959",
  "commerce-permissions": "static-1.673",
  "customer-data-tracking": "static-1.6792",
  "products-iframe-lib": "static-1.7661",
  "products-ui-components-shared-msw-handlers": "static-1.10128",
  "onboarding-data-sync-lib": "static-1.1805",
  "hubspot-apollo-cache": "static-1.244",
  "calling-error-reporting": "static-1.31215",
  "shared-worker-versioning": "static-1.10945",
  "calling-usage-tracker": "static-1.6448",
  "voice-sms-access-library": "static-1.622",
  "conversations-skeleton-state": "static-1.7158",
  "location-customization-utils-lib": "static-1.8941",
  "crm-pipelines-api-client-types": "static-1.4067",
  "framework-builder-read-service-client": "static-1.3934",
  "framework-data-schema-quick-fetch": "static-1.6687",
  "persist-promise": "static-1.3617",
  "directed-graph": "static-1.845",
  "event-emitter": "static-1.855",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.49",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9829",
  "fsm": "static-1.3642",
  "policy-lib": "static-1.6691",
  "react-tinymce": "static-1.54970",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9892",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54096",
  "tinymce-plugins": "static-1.57210",
  "tinymce-themes": "static-1.56066",
  "growth-onboarding-next-action-components": "static-1.1663",
  "user-context-client": "static-1.4519",
  "nest": "static-1.130",
  "unified-auth-core-lib": "static-1.642",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4439",
  "video-embed": "static-1.35462",
  "content-icons-ui": "static-1.2204",
  "social-insights-client-types": "static-1.21813",
  "eligibility-engine-service-types": "static-1.3089",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4717",
  "integrations-lib": "static-1.15809",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4170",
  "InboxConnectUtils": "static-4.14546",
  "calling-orchestration-schema": "static-1.35399",
  "crm-record-cards-service-types": "static-1.3535",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4425",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2950",
  "tinymce-data": "static-1.40181",
  "ui-addon-sales-email": "static-1.5119",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12265",
  "layout-dnd-utils": "static-1.11240",
  "react-codemirror": "static-1.10531",
  "ui-brand-identity-lib": "static-1.14822",
  "NamespacedHubStyle": "static-2.8992",
  "outpost": "static-1.4101",
  "flux-actions": "static-1.325",
  "integrations-error-boundary-lib": "static-1.13224",
  "integrations-tracking-lib": "static-1.5504",
  "native-integrations-shared-strings": "static-1.7693",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10281",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.361",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68141",
  "layout-data-lib": "static-1.9565",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2916",
  "microsoft-drive-integration-lib": "static-1.42",
  "advanced-menus-core": "static-1.14985",
  "advanced-menus-lib": "static-1.11946",
  "ExportDialog": "static-6.10297",
  "ui-memberships-settings-lib": "static-1.33781",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14984",
  "simple-menus-lib": "static-1.16501"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1985",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.457",
  "data-fetching-client": "/data-fetching-client/static-1.9582",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25080",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5501",
  "hs-test-utils": "/hs-test-utils/static-1.7919",
  "hub-http": "/hub-http/static-1.6126",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9746",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17961",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11364",
  "I18n": "/I18n/static-7.1604",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6375",
  "payment-link-components": "/payment-link-components/static-1.23263",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6880",
  "quartz-core": "/quartz-core/static-1.6099",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10116",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5273",
  "rich-text-lib": "/rich-text-lib/static-1.19670",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17854",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5502",
  "UIComponents": "/UIComponents/static-3.8311",
  "foundations-assets": "/foundations-assets/static-1.4757",
  "foundations-components": "/foundations-components/static-1.7739",
  "foundations-theming": "/foundations-theming/static-1.4321",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2037",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.717",
  "quartz-config": "/quartz-config/static-1.658",
  "quartz-routing": "/quartz-routing/static-1.310",
  "quick-fetch": "/quick-fetch/static-1.3841",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16564",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8052",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4676",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9452",
  "usage-tracker": "/usage-tracker/static-1.7243",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5660",
  "usage-tracker-core": "/usage-tracker-core/static-1.7093",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3332",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3157",
  "quartz-webpack": "/quartz-webpack/static-1.3104",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7567",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7831",
  "laboratory-lib": "/laboratory-lib/static-3.7066",
  "onboarding-scopes": "/onboarding-scopes/static-1.6372",
  "rpc-client-utils": "/rpc-client-utils/static-1.4551",
  "ui-addon-opt": "/ui-addon-opt/static-4.8289",
  "HeadJS": "/HeadJS/static-2.736",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3030",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4003",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7616",
  "cssUtils": "/cssUtils/static-1.771",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9733",
  "HubStyle": "/HubStyle/static-2.11672",
  "knowledge-content-types": "/knowledge-content-types/static-1.8453",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.555",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9794",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11056",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8948",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10055",
  "video-components-external": "/video-components-external/static-1.10970",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4231",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5923",
  "customer-data-properties": "/customer-data-properties/static-1.51214",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18228",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4992",
  "onboarding-tours": "/onboarding-tours/static-1.16430",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7998",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8957",
  "user-context": "/user-context/static-1.5008",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4577",
  "icons": "/icons/static-2.639",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.555",
  "quartz-head": "/quartz-head/static-1.545",
  "quartz-test": "/quartz-test/static-1.555",
  "quartz-tracking": "/quartz-tracking/static-1.259",
  "ui-fonts": "/ui-fonts/static-1.626",
  "usage-tracker-container": "/usage-tracker-container/static-1.7233",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9337",
  "data-token-picker": "/data-token-picker/static-1.16241",
  "FileManagerLib": "/FileManagerLib/static-1.38963",
  "property-translator": "/property-translator/static-1.5314",
  "atom": "/atom/static-1.4978",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5701",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5222",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1131",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4008",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1553",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2804",
  "foundations-theming-base": "/foundations-theming-base/static-1.3306",
  "stylex": "/stylex/static-1.30",
  "interframe": "/interframe/static-3.4670",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5657",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4380",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3771",
  "superstore": "/superstore/static-1.4676",
  "chirp-fetch": "/chirp-fetch/static-1.1788",
  "feedback-loader": "/feedback-loader/static-1.29122",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8700",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8604",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28275",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4526",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2401",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8075",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4558",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11944",
  "content-media-compositions": "/content-media-compositions/static-2.15951",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4060",
  "magpie-lib": "/magpie-lib/static-1.5502",
  "magpie-types": "/magpie-types/static-1.4962",
  "media-bridge-lib": "/media-bridge-lib/static-1.18762",
  "video-data-lib": "/video-data-lib/static-1.34628",
  "commerce-products-lib": "/commerce-products-lib/static-1.9184",
  "crm-message-bus": "/crm-message-bus/static-1.42718",
  "growth-data-modal": "/growth-data-modal/static-1.5285",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4785",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4644",
  "calling-global-api": "/calling-global-api/static-1.64131",
  "calling-internal-common": "/calling-internal-common/static-1.31209",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65513",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57807",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3722",
  "crm-links": "/crm-links/static-1.6185",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12928",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9073",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7992",
  "external-options-client-types": "/external-options-client-types/static-1.4083",
  "file-manager-components": "/file-manager-components/static-1.23323",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6782",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3515",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4148",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.537",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3616",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48418",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3891",
  "property-value-citations": "/property-value-citations/static-1.1828",
  "pulse": "/pulse/static-1.452",
  "smart-property-lib": "/smart-property-lib/static-1.6474",
  "tiered-pricing": "/tiered-pricing/static-1.1025",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10898",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2978",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1635",
  "navigation-components": "/navigation-components/static-1.17675",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.496",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7436",
  "ui-universal-auth": "/ui-universal-auth/static-1.8847",
  "batch-promise": "/batch-promise/static-1.1460",
  "navigation-messaging": "/navigation-messaging/static-1.7002",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17346",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9744",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4929",
  "audio-components": "/audio-components/static-1.5778",
  "FileManagerCore": "/FileManagerCore/static-1.38822",
  "FileManagerImages": "/FileManagerImages/static-1.36474",
  "video-components": "/video-components/static-1.12973",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.764",
  "nav-client-types": "/nav-client-types/static-1.2265",
  "purchase-motions-api": "/purchase-motions-api/static-1.5704",
  "self-service-api": "/self-service-api/static-1.10152",
  "signup-constants": "/signup-constants/static-1.18681",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
  "usage-tracker-public": "/usage-tracker-public/static-1.7054",
  "chatspot-core": "/chatspot-core/static-1.20847",
  "ContentUtils": "/ContentUtils/static-1.68066",
  "copilot-toolkit": "/copilot-toolkit/static-1.10864",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6489",
  "reactive-lib": "/reactive-lib/static-1.631",
  "simple-logging-lib": "/simple-logging-lib/static-1.2959",
  "commerce-permissions": "/commerce-permissions/static-1.673",
  "customer-data-tracking": "/customer-data-tracking/static-1.6792",
  "products-iframe-lib": "/products-iframe-lib/static-1.7661",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10128",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1805",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.244",
  "calling-error-reporting": "/calling-error-reporting/static-1.31215",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10945",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6448",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.622",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7158",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8941",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4067",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3934",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6687",
  "persist-promise": "/persist-promise/static-1.3617",
  "directed-graph": "/directed-graph/static-1.845",
  "event-emitter": "/event-emitter/static-1.855",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.49",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9829",
  "fsm": "/fsm/static-1.3642",
  "policy-lib": "/policy-lib/static-1.6691",
  "react-tinymce": "/react-tinymce/static-1.54970",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9892",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54096",
  "tinymce-plugins": "/tinymce-plugins/static-1.57210",
  "tinymce-themes": "/tinymce-themes/static-1.56066",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1663",
  "user-context-client": "/user-context-client/static-1.4519",
  "nest": "/nest/static-1.130",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.642",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4439",
  "video-embed": "/video-embed/static-1.35462",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "social-insights-client-types": "/social-insights-client-types/static-1.21813",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3089",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4717",
  "integrations-lib": "/integrations-lib/static-1.15809",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4170",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14546",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35399",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3535",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4425",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2950",
  "tinymce-data": "/tinymce-data/static-1.40181",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5119",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12265",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11240",
  "react-codemirror": "/react-codemirror/static-1.10531",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14822",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8992",
  "outpost": "/outpost/static-1.4101",
  "flux-actions": "/flux-actions/static-1.325",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13224",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5504",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7693",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10281",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.361",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68141",
  "layout-data-lib": "/layout-data-lib/static-1.9565",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2916",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.42",
  "advanced-menus-core": "/advanced-menus-core/static-1.14985",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11946",
  "ExportDialog": "/ExportDialog/static-6.10297",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33781",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14984",
  "simple-menus-lib": "/simple-menus-lib/static-1.16501"
}
};
